import { render } from "./recruitinfo-mes.vue?vue&type=template&id=2efbc4aa&scoped=true"
import script from "./recruitinfo-mes.vue?vue&type=script&lang=js"
export * from "./recruitinfo-mes.vue?vue&type=script&lang=js"

import "./recruitinfo-mes.vue?vue&type=style&index=0&id=2efbc4aa&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efbc4aa"]])

export default __exports__